export default {
    title: null,
    youtubeId: null,
    youtubeLink: null
}
